import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { subMonths, format, startOfMonth, endOfMonth } from "date-fns";
import { es } from "date-fns/locale";

export interface MonthlyUserGrowth {
  month: string;
  newUsers: number;
  totalUsers: number;
}

export const useGymUserGrowth = (gymId: string) => {
  return useQuery({
    queryKey: ["gym-user-growth", gymId],
    queryFn: async (): Promise<MonthlyUserGrowth[]> => {
      const now = new Date();
      const months: MonthlyUserGrowth[] = [];

      // Get all users from this gym
      const { data: users } = await supabase
        .from("profiles")
        .select("id, created_at")
        .eq("gym_id", gymId);

      // Calculate for last 6 months
      for (let i = 5; i >= 0; i--) {
        const monthDate = subMonths(now, i);
        const monthStart = startOfMonth(monthDate);
        const monthEnd = endOfMonth(monthDate);

        const newUsersInMonth = users?.filter(u => {
          const createdAt = new Date(u.created_at);
          return createdAt >= monthStart && createdAt <= monthEnd;
        }).length || 0;

        const totalUsersUpToMonth = users?.filter(u => {
          const createdAt = new Date(u.created_at);
          return createdAt <= monthEnd;
        }).length || 0;

        months.push({
          month: format(monthDate, "MMM", { locale: es }),
          newUsers: newUsersInMonth,
          totalUsers: totalUsersUpToMonth,
        });
      }

      return months;
    },
    enabled: !!gymId,
  });
};
